import { TextField } from "@mui/material";
import { DatePickerProps } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment, { Moment } from "moment";
import { useState } from "react"
interface BaseProps extends Omit<DatePickerProps<unknown, Moment>, "value" | "onChange" | "renderInput"> {
    value: Moment | null
    onChange: (d: Moment | null) => void
    error: any,
    helperText: any
    fullWidth?: boolean
}
interface DatePickerFieldProps extends BaseProps {
    label: string
    name: string
    initialValue?: string
}

export const DatePickerField = ({ name, label, initialValue, value, onChange, fullWidth, helperText, error, ...props }: DatePickerFieldProps) => {
    // console.log(h)
    //   const { error, getInputProps } = useField(name!);
    // const now = moment().format("DD/MM/YYYY")
    const [_value, setValue] = useState<Moment | null>();
    function _handleChange() { setValue(value) }

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} >
            <DesktopDatePicker
                {...props}
                openTo="year"
                views={['year', 'month', 'day']}
                maxDate={moment().year(3000)}
                label={label}
                value={value}
                onChange={onChange}
                renderInput={(params) => <TextField {...params} name={name} helperText={helperText} error={error} fullWidth={fullWidth} margin="dense" />}
            />
        </LocalizationProvider>
    )
}

export default DatePickerField